import { useNavigate } from "react-router-dom";
import { useMetrics } from "@/lib/use-metrics";
import { useActivity } from "@/lib/use-activity";
import { useSession } from "@/lib/session-context";
import { logout as apiLogout } from "@/lib/api-client";
import { CallCapMeter } from "@/components/CallCapMeter";
import { LeadsTile } from "@/components/LeadsTile";
import { ConsultsTile } from "@/components/ConsultsTile";
import { OrdersTile } from "@/components/OrdersTile";
import { ConversationsTile } from "@/components/ConversationsTile";
import { ActivityFeed } from "@/components/ActivityFeed";
import { FreshnessFooter } from "@/components/FreshnessFooter";

export default function Dashboard() {
  const navigate = useNavigate();
  const { session, clear } = useSession();
  const { data: metrics, loading: metricsLoading, error: metricsError } =
    useMetrics();
  const { rows, loading: activityLoading } = useActivity(20);

  async function handleLogout() {
    try {
      await apiLogout();
    } catch {
      // Proceed anyway — cookie likely cleared or session already invalid.
    }
    clear();
    navigate("/login");
  }

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-wordmark">Mono</div>
        <div className="app-header-right">
          {session?.email && <span>{session.email}</span>}
          <button type="button" onClick={handleLogout} data-testid="logout-button">
            Log out
          </button>
        </div>
      </header>
      <main className="app-main">
        {metricsError && (
          <div
            className="tile tile--accent-amber"
            data-testid="metrics-error"
            style={{ marginBottom: 16 }}
          >
            <div className="tile-label">Can't load metrics</div>
            <div className="tile-subline">{metricsError.message}</div>
          </div>
        )}

        {!metrics && metricsLoading && (
          <div className="centered-state" data-testid="metrics-loading">
            Loading dashboard…
          </div>
        )}

        {metrics && (
          <>
            <div className="tile-grid">
              <CallCapMeter callCap={metrics.callCap} />
              <LeadsTile leads={metrics.leads} />
              <ConsultsTile consults={metrics.consults} />
              <OrdersTile orders={metrics.orders} />
              <ConversationsTile conversations={metrics.conversations} />
            </div>

            <h2 className="section-heading">Recent activity</h2>
            <ActivityFeed rows={rows} loading={activityLoading} />

            <FreshnessFooter freshness={metrics.freshness} />
          </>
        )}
      </main>
    </div>
  );
}
